import { getStatus } from "../../enums/Domain/StatusLookup";
import { StatusDto } from "../../enums/Domain/Status";

export interface IPillLookup {
    statusName: string,
    statusKey: string,
}

export interface IPill {
    statusDto: StatusDto | undefined,
    pillLookup?: IPillLookup | undefined,
    className?: string | undefined

}

export default function Pill({ statusDto, pillLookup, className }: IPill) {
    const status = getStatus(pillLookup ?? statusDto);
    return (
        <div className={`${status?.displayClass || "pill--grey"} ${className ?? ''} display--flex gap--xxs`}>
            <p className="small">{status?.displayValue || "Unknown"}</p>
        </div>
    );
}